// @flow

import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { needsAuth } from '@gandi/authentication';

import { withTranslator } from '@gandi/translate';

import Presenter from './components/Presenter';

export default (compose(
  withTranslator({ propsNamespace: 'translator' }),
  needsAuth,
  withPageMeta(args => ({
    title: args.__("Edit your customer's info - Gandi.net"),
  })),
)(Presenter): React.ComponentType<{}>);
